<input type="checkbox" id="toggle-button-checkbox_{{idForControl}}" style="display:none;" [checked]="initial ? 'checked' : ''" (change)="Toggle($event.target.checked)" />
<label class="toggle-button-switch"
       for="toggle-button-checkbox_{{idForControl}}"></label>
<div class="toggle-button-text">
  <div class="toggle-button-text-on">{{trueText}}</div>
  <div class="toggle-button-text-off">{{falseText}}</div>
</div>
